export const toggleClass = (className, elem) => {
  elem.classList[elem.classList.contains(className) ? 'remove' : 'add'](
    className
  );
};

export const forEach = (fn, iteratee) => {
  Array.prototype.forEach.call(iteratee, fn); // eslint-disable-line prefer-reflect
};

export const createPanelToggle = (elementId, triggers, stateClass) => {
  const panelElement = document.getElementById(elementId);
  const togglePanel = (event) => {
      event.preventDefault();
      toggleClass(stateClass, panelElement);
    },
    addToggleListener = (element) =>
      element.addEventListener('click', togglePanel);

  forEach(addToggleListener, document.querySelectorAll(triggers));
};

/* eslint-disable */
// prettier-ignore
export const serializeForm = (form) => {
  var field, l, s = [];
  if (typeof form == 'object' && form.nodeName == "FORM") {
    var len = form.elements.length;
    for (var i = 0; i < len; i++) {
      field = form.elements[i];
      if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
        if (field.type == 'select-multiple') {
          l = form.elements[i].options.length;
          for (var j = 0; j < l; j++) {
            if (field.options[j].selected)
              s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
          }
        } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
          s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
        }
      }
    }
  }
  return s.join('&').replace(/%20/g, '+');
};
/* eslint-enable */

export const logForNewRelic = (error, data) => {
  if (typeof newrelic !== 'undefined') {
    newrelic.noticeError(error, data); // eslint-disable-line no-undef
  }
};

export const ready = (fn) => {
  if (
    document.attachEvent
      ? document.readyState === 'complete'
      : document.readyState !== 'loading'
  ) {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

/**
 * Returns the value of a cookie
 * @param {string} name The name of the cookie
 * @returns {string} The value of the cookie
 */
export const getCookieValue = (name) => {
  // eslint-disable-next-line prefer-template
  const rgxp = new RegExp(name + '=([A-Za-z0-9-.]+)');
  const cookieCapture = document.cookie.match(rgxp);

  if (cookieCapture && cookieCapture[1]) {
    return cookieCapture[1];
  }

  return '';
};
